import { render, staticRenderFns } from "./blockCoursePricingSettings.vue?vue&type=template&id=1338dab0&scoped=true&"
import script from "./blockCoursePricingSettings.vue?vue&type=script&lang=js&"
export * from "./blockCoursePricingSettings.vue?vue&type=script&lang=js&"
import style0 from "./blockCoursePricingSettings.vue?vue&type=style&index=0&id=1338dab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1338dab0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})
